import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async'; // Helmet ke liye ye best practice hai

// Components
import Navbar from './Components/Navbar';
import Hero from './Components/Hero';
import FloatingAd from './Components/Ads/Sidebar'; 
import NewsDetail from './NewsDetails/Details';
import Login from './Dashboard/Login';
import Dashboard from './Dashboard/Dashboard';
import CategoryPage from './Pages/CategoryPage';
import TaazaTareen from './Pages/AllNews';
import PakistanPage from './Pages/PakistanPage';
import SiyasatPage from './Pages/PoliticsPage';
import BainUlAqwamiPage from './Pages/International';
import SehatPage from './Pages/Health';
import SheharPage from './Pages/CityNews';
import IshtiharatPage from './Pages/Ishtehar';

const MainLayout = ({ children, lang, setLang, darkMode, setDarkMode }) => {
  const location = useLocation();
  const isDashboard = location.pathname === '/dashboard';
  
  return (
    <div 
      className={darkMode ? 'dark' : ''} 
      style={{ 
        direction: lang === 'UR' ? 'rtl' : 'ltr', 
        minHeight: '100vh', 
        background: darkMode ? '#000' : '#fff', 
        color: darkMode ? '#fff' : '#000' 
      }}
    >
      {!isDashboard && <Navbar lang={lang} setLang={setLang} darkMode={darkMode} setDarkMode={setDarkMode} />}
      
      {/* Floating Ad: Navbar ke baad aur content se pehle */}
      {!isDashboard && <FloatingAd />}
      
      {children}
    </div>
  );
};

function App() {
  const [lang, setLang] = useState('UR');
  const [darkMode, setDarkMode] = useState(false);
  const [isAuthenticated, setAuthenticated] = useState(localStorage.getItem('auth') === 'true');

  return (
    <HelmetProvider>
      <Router>
        <MainLayout lang={lang} setLang={setLang} darkMode={darkMode} setDarkMode={setDarkMode}>
          <Routes>
            <Route path="/" element={<Hero lang={lang} />} />
            <Route path="/news/:id" element={<NewsDetail lang={lang} />} />
            <Route path="/login" element={<Login setAuthenticated={setAuthenticated} />} />
            <Route path="/dashboard" element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" />} />
            <Route path="/category/:categoryName" element={<CategoryPage lang={lang} />} />
            <Route path="/category/Taza Tareen" element={<TaazaTareen lang={lang} />} />
            <Route path="/category/Pakistan" element={<PakistanPage lang={lang} />} />
            <Route path="/category/Siyasat" element={<SiyasatPage lang={lang} />} />
            <Route path="/category/Bain-Ul-Aqwami" element={<BainUlAqwamiPage lang={lang} />} />
            <Route path="/category/Sehat" element={<SehatPage lang={lang} />} />
            {/* <Route path="/category/Shehar" element={<SheharPage lang={lang} />} /> */}
            {/* <Route path="/category/:Shehar-Ki-News" element={<SheharPage lang={lang} />} /> */}
            {/* <Route path="/category/Shehar%20Ki%20News" element={<SheharPage lang={lang} />} /> */}
            <Route path="/category/:Ishtiharat" element={<IshtiharatPage lang={lang} />} />
          </Routes>
        </MainLayout>
      </Router>
    </HelmetProvider>
  );
}

export default App;